'use strict';
namespace Core.Collections {

    export class Dictionary<T> {

        private _items:{ [index:string]:T } = {};
        private _count:number = 0;

        public add(key:string, value:T) {
            if (this.containsKey(key)) {
                throw new TypeError('Key already exists');
            }
            this._items[key] = value;
            this._count++;
        }

        public containsKey(key:string):boolean {
            return this._items.hasOwnProperty(key);
        }

        public count():number {
            return this._count;
        }

        public item(key:string):T {
            return this._items[key];
        }

        public values():T[] {
            let v:T[] = [];

            for (let p in this._items) {
                if (this._items.hasOwnProperty(p)) {
                    v.push(this._items[p]);
                }
            }
            return v;
        }
    }

}

